import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ELearningDashboardClass, ELearningDashboardStudent } from '../../Elearning-Models';
import { IStateService } from '../../Services/state-service';

@Component({
  selector: 'app-elearningdash-student-view',
  templateUrl: './elearningdash-student-view.component.html',
  styleUrls: ['./elearningdash-student-view.component.scss']
})
export class ElearningdashStudentViewComponent implements OnInit {


  @Input() student: ELearningDashboardStudent;
  @Input() classData: ELearningDashboardClass;
  @Output() saveStateEmitter: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }
  
  saveState($event: any){
    let isNotDisabled = $event.target.disabled;
    if(isNotDisabled){
      this.saveStateEmitter.emit();
    }
  }

  
}
